<!-- 联盟成员的内部管理人员列表 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.addNotices" @click="showNoticeDialog()">添加公告</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">公告标题</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Title" placeholder="请输入公告标题"></el-input>
                <div class="search-name">发布时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column min-width="120px" prop="Title" label="公告标题" show-overflow-tooltip> </el-table-column>
                    <el-table-column min-width="200px" prop="Content" label="公告内容" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" prop="Roles" label="可读角色" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="PublishTime" label="发布时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="StopShowTime" label="停止展示时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" prop="Publisher" label="发布人" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="showNoticeDialog(scope.row.NoticeId)" v-if="permission.editNotices">{{
                                    permission.editNotices
                                }}</el-button>
                                <el-button type="text" size="mini" style="color: red" @click="delNotice(scope.row.NoticeId)" v-if="permission.delNotices">{{
                                    permission.delNotices
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" :title="noticeTitle" :visible.sync="dialogNoticeVisible" width="1000px">
            <div class="dialog-content" v-if="dialogNoticeVisible">
                <UnionNoticeEdit ref="unionNoticeEdit" :noticeId="noticeId" @closeDialog="closeNoticeDialog"></UnionNoticeEdit>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import UnionNoticeEdit from '@/components/entpUnion/entityManage/unionNoticeEdit';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'unionNotice',
    components: {
        elTableColumn,
        breadcrumb,
        UnionNoticeEdit
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Title: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            loading: false,
            dateTimes: '',
            noticeTitle: '',
            noticeId: '',
            dialogNoticeVisible: false,
            tableData: [],
            tableDataLength: 0,
            permission: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getUnionPermission('NoticeManage');
        this.getTableData();
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Title: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            };
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionNoticeList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showNoticeDialog(noticeId) {
            this.dialogNoticeVisible = true;
            if (noticeId) {
                this.noticeId = noticeId;
                this.noticeTitle = '编辑联盟公告';
            } else {
                this.noticeTitle = '新增联盟公告';
                this.noticeId = '';
            }
        },
        closeNoticeDialog(isEdit) {
            this.dialogNoticeVisible = false;
            if (isEdit) this.getTableData();
        },
        delNotice(noticeId) {
            let that = this;
            if (noticeId) {
                that.$confirm('您确定要删除该联盟公告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/DelUnionNotice',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    NoticeId: noticeId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('成功删除联盟公告');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>
